<template>
  <!-- eslint-disable-next-line local-rules/no-global-i18n-component -->
  <i18n-t :keypath="keypath" scope="global" :tag="tag">
    <template v-for="(_value, key) in $slots" #[key]>
      <slot :name="key" />
    </template>
  </i18n-t>
</template>

<script setup lang="ts">
defineProps({
  tag: {
    type: [String, Boolean, Object],
    default: 'span'
  },
  keypath: {
    type: String,
    required: true
  }
});
</script>
